import { Directive, Input } from '@angular/core';
import { LunaEntity } from '../../builder/models/entity.model';
import { AbstractControl, FormGroup, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';


export function entityListValidator(entityList: Array<LunaEntity>): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const name = control.get('name');
        var entity: LunaEntity;
        if (entityList.length > 0) {
            entity = entityList.filter(e => { e.entityName === name.value })[0];
            return control.value === entity.entityName ? { 'entityNotUnique': true } : null;
        } else return null;
    }
};

@Directive({
    selector: '[appUniqueEntity]',
    providers: [{ provide: NG_VALIDATORS, useExisting: UniqueEntityDirective, multi: true }],
    standalone: false
})
export class UniqueEntityDirective implements Validator {
    @Input("entityList") entityList: Array<LunaEntity>;
    validate(control: AbstractControl): { [key: string]: any } | null {
        return this.entityList ? entityListValidator(this.entityList)(control)
            : null;
    }
}
